import { TFunction } from "i18next";
import { FeatureTabData } from "./types";
import { featuresData } from "./data/featuresData";

export const buildTabsFromTranslation = (t: TFunction): FeatureTabData[] => {
    return featuresData.map((data) => {
        return {
            id: data.id,
            title: t(data.titleKey),
            iconKey: data.iconKey,
            description: t(data.descKey),
            color: data.color,
            scenarios: data.scenarios.map((scenario) => ({
                iconKey: scenario.iconKey,
                title: t(scenario.titleKey),
                description: t(scenario.descKey),
            })),
        };
    });
};
